import { render } from "./objective-list.vue?vue&type=template&id=7a70944b&ts=true"
import script from "./objective-list.vue?vue&type=script&lang=ts"
export * from "./objective-list.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__